import script from "./DataListControls.vue?vue&type=script&setup=true&lang=js"
export * from "./DataListControls.vue?vue&type=script&setup=true&lang=js"

import "./DataListControls.vue?vue&type=style&index=0&id=eee98642&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eee98642"]])

export default __exports__